import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const HockeyIcon = observer('HockeyIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='hockeyMask'
                width='14'
                height='12'
                x='1'
                y='2'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#142448'
                    d='M1.333 13.433v-2q0-.283.192-.475A.65.65 0 0 1 2 10.767h.667v2.666zm2 0v-2.666H6l.567-1.3L7.633 11.8l-.566 1.267a.57.57 0 0 1-.25.275.7.7 0 0 1-.35.091zm10 0v-2.666H14q.283 0 .475.191a.65.65 0 0 1 .192.475v2zm-.666 0H9.533a.7.7 0 0 1-.35-.091.57.57 0 0 1-.25-.275l-4.7-10.3h2.234L8 6.233l1.533-3.466h2.234l-2.7 5.9.933 2.1h2.667z'
                />
            </mask>
            <g mask='url(#hockeyMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
